import { Component, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { Menu } from 'primeng/menu';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-main-menu',
  imports: [
    FormsModule,
    MenubarModule, Menu, Button, Dialog, InputText],
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.scss'
})
export class MainMenuComponent {

  items: MenuItem[] | undefined = [];
  userItems: MenuItem[] | undefined = [];
  username: string = "";
  dealLocator = false;
  dealId: number | null = null;

  @ViewChild('dealInput') dealInput: any | null = null;

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.setup();

    this.authService.usernameChanged.subscribe(username => {
      this.setup();
    });
  }

  setup() {
    this.username = this.authService.getUsername();

    this.userItems = [
      {
        label: 'Toggle Dark mode',
        icon: 'pi pi-sun',
        command: () => {
          this.authService.toggleDarkMode();
        }
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => {
          this.authService.logout();
          this.router.navigate(['/login']);
        }
      }
    ];

    this.items = this.roleAccess([
      {
        label: 'Home',
        icon: 'pi pi-home',
        routerLink: '/'
      },
      {
        label: 'Deals',
        icon: 'pi pi-euro',
        items: [
          {
            label: 'Payments',
            routerLink: 'deals/payments'
          },
          {
            label: 'Upcoming Renewals',
            routerLink: 'deals/renewals'
          },
          {
            label: 'Overdues',
            routerLink: 'deals/overdues'
          },
          {
            label: 'Pending Deals',
            routerLink: 'deals/overdue-payments'
          },
          {
            separator: true
          },
          {
            label: 'Locate',
            roles: ['DealManager'],
            command: () => {
              this.dealId = null;
              this.dealLocator = true;

              if (this.dealInput) {
                setTimeout(() => {
                  this.dealInput.nativeElement.focus();
                }, 400);
              }
            }
          }
        ]
      },
      {
        label: 'Notifications',
        icon: 'pi pi-id-card',
        items: [
          {
            label: 'Upcoming notifications',
            routerLink: 'notifications/upcoming'
          },
        ]
      },
      {
        label: 'Campaigns',
        icon: 'pi pi-volume-up',
        routerLink: 'campaigns'
      },
      {
        label: 'Accounting',
        icon: 'pi pi-briefcase',
        items: [
          {
            label: 'Tabs',
            routerLink: 'accounting/tabs'
          },
        ]
      },
    ])
  }

  roleAccess(menuItems: (MenuItem & { roles?: string[] })[]): MenuItem[] {
    const accessibles: MenuItem[] = [];

    for (const mi of menuItems) {
      if (mi.roles != null && mi.roles.length > 0 && !this.authService.hasRoles(mi.roles)) {
        continue;
      }

      if (mi.routerLink != null && mi.routerLink != '' && !this.canAccessMenu(mi)) {
        continue;
      }

      const clone = { ...mi };
      clone.items = [];

      if (mi.items != null && mi.items.length > 0) {
        clone.items = this.roleAccess(mi.items);
        if (clone.items.filter(i => i.separator != true).length == 0) {
          continue;
        }

        accessibles.push(clone);
      } else {
        accessibles.push(clone);
      }
    }

    return accessibles
  }

  canAccessMenu(menuItem: MenuItem): boolean {
    const routeDefinitions = this.router.config;
    const definition = routeDefinitions.find(r => r.path == menuItem.routerLink);
    if (definition == null) {
      return true;
    }

    const roles = definition.data == null || definition.data['roles'] == null ? [] : definition.data["roles"] as (string[] | null);
    return this.authService.hasRoles(roles);
  }

  dealKeyPressed($event: any) {
    if (this.dealId != null && this.dealId > 0) {
      this.locateDeal();
    }

  }

  locateDeal() {
    this.dealLocator = false;
    this.router.navigate(['/deals/edit', this.dealId]);
  }
}
